<mat-spinner [diameter]="20" [id]="data.id">
</mat-spinner>

{{data.message}}
